/**
 * @file Global CSS media queries
 */

module.exports = {
	BREAKPOINT_DESKTOP: 1024,
	desktop: `@media (min-width: 1024px)`,
}
